/**
 * Converte um enum e seu mapa de tradução em uma lista de opções `{ key, text }`
 * para uso em selects ou dropdowns.
 *
 * @template T - Tipo dos valores do enum (string ou number).
 * @param enumObject - Enum a ser convertido.
 * @param translationMap - Mapa de traduções dos valores do enum.
 * @returns Lista de opções formatadas.
 *
 * @example
 * enum StatusEnum {
 *   ACTIVE = "active",
 *   INACTIVE = "inactive"
 * }
 *
 * const TranslatedStatusEnum = {
 *   [StatusEnum.ACTIVE]: "Ativo",
 *   [StatusEnum.INACTIVE]: "Inativo"
 * };
 *
 * enumToOptions(StatusEnum, TranslatedStatusEnum);
 * // → [ { key: "active", text: "Ativo" }, { key: "inactive", text: "Inativo" } ]
 */
export function enumToOptions<T extends string | number>(
  enumObject: Record<string, T>,
  translationMap: Record<T, string>
): { key: T; text: string }[] {
  return Object.values(enumObject).map(value => ({
    key: value,
    text: translationMap[value]
  }));
}
